import yup from 'src/utils/yup';
import createTypedAction from '../createTypedAction';

export const PREFIX = '@@fox/dashboard/';

export const { fetchDeviceGroups, FETCH_DEVICE_GROUPS }: any = createTypedAction(
  `${PREFIX}FETCH_DEVICE_GROUPS`,
  ['paginationDetails', yup.object().nullable()],
);

export const { fetchDeviceGroupsSuccess, FETCH_DEVICE_GROUPS_SUCCESS }: any = createTypedAction(
  `${PREFIX}FETCH_DEVICE_GROUPS_SUCCESS`,
  ['groups', yup.immutable().list().required()],
  ['total', yup.number().required()],
  ['totalPages', yup.number()]
);

export const { fetchDeviceGroupsFailed, FETCH_DEVICE_GROUPS_FAILED }: any = createTypedAction(
  `${PREFIX}FETCH_DEVICE_GROUPS_FAILED`,
  ['err', yup.immutable().map().nullable()]
);

export const { fetchDeviceGroupsLabels, FETCH_DEVICE_GROUPS_LABELS }: any = createTypedAction(
  `${PREFIX}FETCH_DEVICE_GROUPS_LABELS`
);

export const { fetchDeviceGroupsLabelsSuccess, FETCH_DEVICE_GROUPS_LABELS_SUCCESS }: any = createTypedAction(
  `${PREFIX}FETCH_DEVICE_GROUPS_LABELS_SUCCESS`,
  ['groups', yup.immutable().list().required()],
);

export const { fetchDeviceGroupsLabelsFailed, FETCH_DEVICE_GROUPS_LABELS_FAILED }: any = createTypedAction(
  `${PREFIX}FETCH_DEVICE_GROUPS_FAILED`,
  ['err', yup.immutable().map().nullable()]
);

export const { deleteDeviceGroup, DELETE_DEVICE_GROUP }: any = createTypedAction(
  `${PREFIX}DELETE_DEVICE_GROUP`,
  ['groupId', yup.string().required()],
);

export const { deleteDeviceGroupSuccess, DELETE_DEVICE_GROUP_SUCCESS }: any = createTypedAction(
  `${PREFIX}DELETE_DEVICE_GROUP_SUCCESS`,
  ['groupId', yup.immutable().map()],
);

export const { deleteDeviceGroupFailed, DELETE_DEVICE_GROUP_FAILED }: any = createTypedAction(
  `${PREFIX}DELETE_DEVICE_GROUP_FAILED`,
  ['err', yup.immutable().map().nullable()]
);

export const { createDeviceGroup, CREATE_DEVICE_GROUP }: any = createTypedAction(
  `${PREFIX}CREATE_DEVICE_GROUP`,
  ['groupName', yup.string().required()],
  ['deviceIds', yup.immutable().list()],
  ['redirectOnSuccess', yup.boolean()]
);

export const { createDeviceGroupSuccess, CREATE_DEVICE_GROUP_SUCCESS }: any = createTypedAction(
  `${PREFIX}CREATE_DEVICE_GROUP_SUCCESS`,
  ['groupName', yup.string().required()],
  ['deviceIds', yup.immutable().list()],
  ['id', yup.string().required()],
  // deviceIds is capped by the API, so the full membership size comes across separately
  ['count', yup.number()]
);

export const { createDeviceGroupFailed, CREATE_DEVICE_GROUP_FAILED }: any = createTypedAction(
  `${PREFIX}CREATE_DEVICE_GROUP_FAILED`,
  ['err', yup.immutable().map().nullable()]
);

export const { updateDeviceGroup, UPDATE_DEVICE_GROUP }: any = createTypedAction(
  `${PREFIX}UPDATE_DEVICE_GROUP`,
  ['groupId', yup.string().required()],
  ['groupName', yup.string().required()],
  ['deviceIds', yup.immutable().list()],
  ['redirectOnSuccess', yup.boolean()]
);

export const { updateDeviceGroupSuccess, UPDATE_DEVICE_GROUP_SUCCESS }: any = createTypedAction(
  `${PREFIX}UPDATE_DEVICE_GROUP_SUCCESS`,
  ['groupId', yup.string().required()],
  ['groupName', yup.string().required()],
  ['deviceIds', yup.immutable().list()],
  // deviceIds is capped by the API, so the full membership size comes across separately
  ['count', yup.number()]
);

export const { updateDeviceGroupFailed, UPDATE_DEVICE_GROUP_FAILED }: any = createTypedAction(
  `${PREFIX}UPDATE_DEVICE_GROUP_FAILED`,
  ['err', yup.immutable().map().nullable()]
);

// The edit screen's own fetch. Kept distinct from the listing's actions because the listing may
// hold a partial device list for a group, while editing needs the whole membership — so the two
// results are stored apart rather than overwriting each other in one shared record.
export const { fetchDeviceGroupForEdit, FETCH_DEVICE_GROUP_FOR_EDIT }: any = createTypedAction(
  `${PREFIX}FETCH_DEVICE_GROUP_FOR_EDIT`,
  ['groupId', yup.string().required()],
);

export const { fetchDeviceGroupForEditSuccess, FETCH_DEVICE_GROUP_FOR_EDIT_SUCCESS }: any = createTypedAction(
  `${PREFIX}FETCH_DEVICE_GROUP_FOR_EDIT_SUCCESS`,
  ['group', yup.immutable().map()],
);

export const { fetchDeviceGroupForEditFailed, FETCH_DEVICE_GROUP_FOR_EDIT_FAILED }: any = createTypedAction(
  `${PREFIX}FETCH_DEVICE_GROUP_FOR_EDIT_FAILED`,
  ['err', yup.immutable().map().nullable()]
);

// The list only fetches the first page of each group's devices. Expanding a row pulls the rest on
// demand rather than making every list load pay for the full membership up front.
export const { expandDeviceGroupDevices, EXPAND_DEVICE_GROUP_DEVICES }: any = createTypedAction(
  `${PREFIX}EXPAND_DEVICE_GROUP_DEVICES`,
  ['groupId', yup.string().required()],
);

export const { expandDeviceGroupDevicesSuccess, EXPAND_DEVICE_GROUP_DEVICES_SUCCESS }: any = createTypedAction(
  `${PREFIX}EXPAND_DEVICE_GROUP_DEVICES_SUCCESS`,
  ['groupId', yup.string().required()],
  ['devices', yup.immutable().list()],
);

export const { expandDeviceGroupDevicesFailed, EXPAND_DEVICE_GROUP_DEVICES_FAILED }: any = createTypedAction(
  `${PREFIX}EXPAND_DEVICE_GROUP_DEVICES_FAILED`,
  ['groupId', yup.string().required()],
  ['err', yup.immutable().map().nullable()]
);
